import ky from "ky";

document.addEventListener(
    `DOMContentLoaded`,
    () => {
        const favoriteButtons = document.querySelectorAll("[data-favorite-button]");

        favoriteButtons.forEach((button) => {
            button.addEventListener(
                "click",
                async function (event) {
                    const postID = this.dataset.postId;
                    if (!postID) return;

                    const iconElement = button.querySelector("iconify-icon");
                    const originalIconHTML = iconElement ? iconElement.outerHTML : "";

                    iconElement.outerHTML =
                        '<iconify-icon class="iconify icon-spin" icon="fas:spinner"></iconify-icon>';

                    const action = this.dataset.action;
                    if (action === "add") {
                        await handleFavorite("add_to_favorites", postID, button, true, originalIconHTML);
                    } else if (action === "remove") {
                        await handleFavorite("remove_from_favorites", postID, button, false, originalIconHTML);
                    }
                },
                { passive: true },
            );
        });

        async function handleFavorite(action, postID, button, isAdding, originalIconHTML) {
            const formData = new FormData();
            formData.append("action", action);
            formData.append("security", frameworkGlobal.nonce);
            formData.append("post_id", postID);

            try {
                const response = await ky.post(frameworkGlobal.ajaxurl, { body: formData }).json();
                if (response.success) {
                    button.classList.toggle("is-favorited", isAdding);
                    button.querySelector("iconify-icon").outerHTML = isAdding
                        ? frameworkGlobal.wpsoup.favorites.button_icon_favorited
                        : frameworkGlobal.wpsoup.favorites.button_icon_unfavorited;
                    button.dataset.action = isAdding ? "remove" : "add";

                    const customEvent = new CustomEvent("favoriteToggled", {
                        detail: {
                            postId: postID,
                            button: button,
                            response: response,
                            isAdding: isAdding,
                        },
                        bubbles: false,
                        cancelable: false,
                    });

                    button.dispatchEvent(customEvent);
                    document.dispatchEvent(customEvent);
                } else {
                    button.querySelector("iconify-icon").outerHTML = originalIconHTML;
                }
            } catch (error) {
                button.querySelector("iconify-icon").outerHTML = originalIconHTML;
            }
        }
    },
    { passive: true },
);
